export default __webpack_public_path__ + "static/media/2icon.2a761f3b.svg";